export default __webpack_public_path__ + "static/media/petfinder-logo.ed7f3df5.svg";